// resources/js/admin/services/pageMediaService.ts

import axios from "axios";
import { PageMedia, PageMediaAttachData, PageMediaSyncData } from "../types/features/PageMedia";
import { MAIN_API_URL } from "../config/api";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const pageMediaService = {
  // 🔒 PROTÉGÉ - Token requis (AVEC PAGINATION)
  async getByPage(
    token: string,
    pageId: string,
    page: number = 1,
    perPage: number = 20
  ): Promise<PaginatedResponse<PageMedia>> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/pages/${pageId}/media`, {
        params: { page, per_page: perPage },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des médias de la page", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async getByField(
    token: string,
    pageId: string,
    field: string,
    page: number = 1,
    perPage: number = 20
  ): Promise<PaginatedResponse<PageMedia>> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/pages/${pageId}/media/field/${field}`, {
        params: { page, per_page: perPage },
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des médias par champ", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async attach(token: string, pageId: string, data: PageMediaAttachData): Promise<PageMedia> {
    try {
      const response = await axios.post(`${MAIN_API_URL}/pages/${pageId}/media/attach`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error: any) {
      console.error("Erreur lors de l'attachement du média", error.response);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async detach(token: string, pageId: string, mediaId: string): Promise<void> {
    try {
      await axios.delete(`${MAIN_API_URL}/pages/${pageId}/media/detach/${mediaId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors du détachement du média", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async sync(token: string, pageId: string, data: PageMediaSyncData): Promise<PageMedia[]> {
    try {
      const response = await axios.post(`${MAIN_API_URL}/pages/${pageId}/media/sync`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la synchronisation des médias", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async updatePosition(
    token: string,
    pageId: string,
    mediaId: string,
    position: number,
    field?: string
  ): Promise<PageMedia> {
    try {
      const response = await axios.put(
        `${MAIN_API_URL}/pages/${pageId}/media/${mediaId}/position`,
        { position, field },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la position", error);
      throw error;
    }
  },
};